import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface FileExtensionsInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: string;
    editTitle: string;
    editAlias: string;
    editActive: boolean;
    deleteStatusModalVisible: boolean;
    deleteId?: string;
}

function getInitialState(): FileExtensionsInterface {
    return {
        formVisible: false,
        formVariant: "new",
        editId: "",
        editTitle: "",
        editAlias: "",
        editActive: true,
        deleteStatusModalVisible: false,
    };
}

export const FileExtensionsSlice = createSlice({
    name: "FileExtensionsSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),
        updateFields: (
          state: FileExtensionsInterface,
          action: PayloadAction<Partial<FileExtensionsInterface>>
        ) => {
            Object.assign(state, action.payload);
        },

    },

});

export const {updateFields, reset} = FileExtensionsSlice.actions;

export const FileExtensionsSelectors = {
    formVisible: (state: RootState) => state.fileExtensions.formVisible,
    formVariant: (state: RootState) => state.fileExtensions.formVariant,
    editId: (state: RootState) => state.fileExtensions.editId,
    editTitle: (state: RootState) => state.fileExtensions.editTitle,
    editAlias: (state: RootState) => state.fileExtensions.editAlias,
    editActive: (state: RootState) => state.fileExtensions.editActive,
    deleteModalVisible: (state: RootState) => state.fileExtensions.deleteStatusModalVisible,
    deleteId: (state: RootState) => state.fileExtensions.deleteId,
};

export const FileExtensionsReducer = FileExtensionsSlice.reducer;
